/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AIModelTrainingRequest
 */
export interface AIModelTrainingRequest {
    /**
     * 
     * @type {string}
     * @memberof AIModelTrainingRequest
     */
    name: string | null;
    /**
     * 
     * @type {string}
     * @memberof AIModelTrainingRequest
     */
    dataset: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AIModelTrainingRequest
     */
    categories?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AIModelTrainingRequest
     */
    continueFrom?: string | null;
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof AIModelTrainingRequest
     */
    parameters: { [key: string]: string | undefined; };
}

export function AIModelTrainingRequestFromJSON(json: any): AIModelTrainingRequest {
    return AIModelTrainingRequestFromJSONTyped(json, false);
}

export function AIModelTrainingRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AIModelTrainingRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'dataset': json['dataset'],
        'categories': !exists(json, 'categories') ? undefined : json['categories'],
        'continueFrom': !exists(json, 'continue_from') ? undefined : json['continue_from'],
        'parameters': json['parameters'],
    };
}

export function AIModelTrainingRequestToJSON(value?: AIModelTrainingRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'dataset': value.dataset,
        'categories': value.categories,
        'continue_from': value.continueFrom,
        'parameters': value.parameters,
    };
}


